/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetUsersPreferencesUnitsOptions, GetUsersPreferencesUnitsResponses } from '../types/GetUsersPreferencesUnits'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /users/preferences/units/}
 */
export function getUsersPreferencesUnits<ThrowOnError extends boolean = true>(options: Options<GetUsersPreferencesUnitsOptions, ThrowOnError> = {}): Unwrappable<RequestResult<GetUsersPreferencesUnitsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'GET', url: '/users/preferences/units/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetUsersPreferencesUnitsResponses, ThrowOnError>>)
}
